import React from 'react';
import useDeviceDetection from '../../hooks/useDeviceDetection';
import { CtaButton } from '../FooterBottom/FooterBottom.styles';
import { Wrapper, Title, ButtonWrapper, Column, Text } from './TwoColumn.styles';

const TwoColumnText = ({ mainTitle, text, linkTitle, ctaUrl }) => {
  const { isTablet } = useDeviceDetection();
  return (
    <Wrapper>
      <Column>
        {mainTitle && <Title>{mainTitle}</Title>}
        {ctaUrl && linkTitle && isTablet && (
          <ButtonWrapper>
            <CtaButton href={ctaUrl.url} type={ctaUrl.type} size="large">
              {linkTitle}
            </CtaButton>
          </ButtonWrapper>
        )}
      </Column>
      <Column>
        {text && <Text dangerouslySetInnerHTML={{ __html: text }} />}
        {ctaUrl && linkTitle && !isTablet && (
          <ButtonWrapper>
            <CtaButton href={ctaUrl.url} type={ctaUrl.type} size="large">
              {linkTitle}
            </CtaButton>
          </ButtonWrapper>
        )}
      </Column>
    </Wrapper>
  );
};

export default TwoColumnText;
